'use strict';

angular.module('mean.projects').factory('tradeService', ['$filter', 'toaster',
    function ($filter, toaster) {
        var updateTablePlan = function (task_list, bid_tasks, bid, my_trade, plan) {
            task_list.forEach(function (task, index) {
                if (task.trade === my_trade) {
                    bid.forEach(function (bid, ii) {

                        if (bid.task_id === task._id) {
                            if (bid.plan_code === plan) {
                                bid.subtasks.forEach(function (subtask, si) {
                                    task.subtasks.forEach(function (tsub, tsi) {
                                        if (subtask.task_id === tsub._id) {
                                            tsub.quantity = Number(subtask.quantity);
                                            tsub.bid_hours = Number(subtask.bid_hours);
                                            tsub.labor = Number(subtask.labor);
                                        }
                                    });
                                    if (!subtask.equipment) subtask.equipment = [];
                                    subtask.equipment.forEach(function (eq, eidx) {
                                        task.subtasks[si].equipment.forEach(function (teq, teidx) {
                                            if (eq.equipment_id === teq._id) {
                                                teq.quantity = Number(eq.quantity);
                                                if (eq.price_per_order)
                                                    teq.price_per_order = Number(eq.price_per_order);
                                                if (eq.delivery_price)
                                                    teq.delivery_price = Number(eq.delivery_price);
                                            }
                                        });
                                    });
                                    if (!subtask.materials) subtask.materials = [];
                                    subtask.materials.forEach(function (mq, midx) {
                                        task.subtasks[si].materials.forEach(function (tmq, tmidx) {
                                            if (mq.material_id === tmq._id && tmq._id) {
                                                tmq.quantity = Number(mq.quantity);
                                                if (tmq.piece_per_size)
                                                    mq.piece_per_size = tmq.piece_per_size;
                                                if (mq.price_per_order)
                                                    tmq.price_per_order = Number(mq.price_per_order);
                                                if (mq.delivery_price)
                                                    tmq.delivery_price = Number(mq.delivery_price);
                                            }
                                        });
                                    });
                                });
                            } else {
                                var bid_found = false;
                                for (var i = 0; i < bid.length; i = i + 1) {
                                    if (bid[i].task_id === task._id &&
                                        bid[i].plan_code === plan)
                                        bid_found = true;
                                }

                                if (!bid_found) {
                                    task.subtasks.forEach(function (sub) {
                                        sub.quantity = 0;
                                        sub.bid_hours = 0;
                                        sub.labor = 0;
                                        sub.materials.forEach(function (mat) {
                                            mat.quantity = 0;
                                            mat.materials_subtotal = 0;
                                            mat.materials_dev_subtotal = 0;
                                        });
                                        sub.equipment.forEach(function (eq) {
                                            eq.quantity = 0;
                                            eq.materials_subtotal = 0;
                                            eq.materials_dev_subtotal = 0;
                                        });
                                    });
                                }
                            }
                        }
                    });

                    bid_tasks.push(task);
                }
            });

            bid_tasks = $filter('orderBy')(bid_tasks, '_id');

            return bid_tasks;
        };

        var updateLaborRates = function (task_list, subtasks, my_bid_trade) {
            var filtered_task_list = $filter('filter')(task_list, {
                'trade': my_bid_trade
            }, true);

            for (var i = 0; i < filtered_task_list.length; i++) {
                var subs = $filter('filter')(subtasks, {
                    'trade': filtered_task_list[i].trade,
                    'task': filtered_task_list[i].task
                }, true);

                for (var j = 0; j < subs.length; j++) {
                    var update = $filter('filter')(filtered_task_list[i].subtasks, {
                        'name': subs[j].name
                    }, true);

                    for (var k = 0; k < update.length; k++) {
                        update[k].piece_per_hour_rate = subs[j].piece_per_hour_rate;
                        update[k].piece_per_size = subs[j].piece_per_size;
                        update[k].piece_rate = subs[j].piece_rate;
                        update[k].crew_rate = subs[j].crew_rate;
                    }
                }
            }
        };

        var updateMaterialRates = function (task_list, materials, my_bid_trade) {
            var filtered_task_list = $filter('filter')(task_list, {
                'trade': my_bid_trade
            }, true);

            _.each(filtered_task_list, function (task) {
                _.each(task.subtasks, function (subtask, j) {
                    _.each(subtask.materials, function (material, k) {
                        var mat = $filter('filter')(materials, {
                            'name': material.name, 'supplier': material.supplier
                        }, true)[0];

                        if (mat) {
                            material.unit = mat.unit.unit;
                            material.units_per_order = mat.units_per_order;
                            material.price_per_order = mat.price_per_order;
                            material.piece_per_size = mat.piece_per_size;
                            material.delivery_price = mat.delivery_price;
                        } else {
                            console.log('Material ' + material.name +
                                ' from supplier ' + material.supplier +
                                ' was not found from general material list to get an update')
                        }
                    });
                });
            });
        };

        var updateEquipmentRates = function (task_list, equipment, my_bid_trade) {
            var filtered_task_list = $filter('filter')(task_list, {
                'trade': my_bid_trade
            }, true);

            _.each(filtered_task_list, function (task) {
                _.each(task.subtasks, function (subtask, j) {
                    _.each(subtask.equipment, function (equip, k) {
                        var eq = $filter('filter')(equipment, {
                            'name': equip.name, 'supplier': equip.supplier
                        }, true)[0];

                        if (eq) {
                            equip.unit = eq.unit.unit;
                            equip.units_per_order = eq.units_per_order;
                            equip.price_per_order = eq.price_per_order;
                            equip.piece_per_size = eq.piece_per_size;
                            equip.delivery_price = eq.delivery_price;
                        } else {
                            console.log('Equipment ' + equip.name +
                                ' from supplier ' + equip.supplier +
                                ' was not found from general equipment list to get an update')
                        }
                    });
                });
            });
        };
        var clearMaterials = function (task_list, my_bid_trade) {
            var filtered_task_list = $filter('filter')(task_list, {
                'trade': my_bid_trade
            }, true);

            for (var i = 0; i < filtered_task_list.length; i++) {
                for (var j = 0; j < filtered_task_list[i].subtasks.length; j++) {
                    filtered_task_list[i].subtasks[j].materials = [];
                }
            }
        };

        return {
            updateTablePlan: updateTablePlan,
            updateLaborRates: updateLaborRates,
            updateMaterialRates: updateMaterialRates,
            updateEquipmentRates: updateEquipmentRates,
            clearMaterials: clearMaterials
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/trades/public/services/trade-service.js